import clsx from 'clsx';
import { Icon, SelectCustomizable } from 'ui';
import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import useInputPointsQualitativeScale from './useInputPointsQualitativeScale';

const InputPointsQualitativeScale = ({
  onChange,
  disabled,
  size,
  isScoreReadOnly,
  showDotted,
  isLate,
  colorsPoints,
  evaluationScale,
  changeError,
  t,
  ...props
}) => {
  const { hasError, onChangeOption, onFocus, onBlur, statusColor, options, selectedOption } = useInputPointsQualitativeScale({
    props,
    onChange,
    colorsPoints,
    changeError,
    evaluationScale,
  });

  return (
    <div className={clsx('input-points', `input-points--status-${statusColor}`, { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <SelectCustomizable
          className="input-points-qualitative__input"
          onFocus={onFocus}
          onBlur={onBlur}
          isDisabled={disabled || isScoreReadOnly}
          value={selectedOption || null}
          options={options}
          onChange={onChangeOption}
          placeholder={disabled || isScoreReadOnly ? '' : t('actions:Select')}
          defaultValue={selectedOption || null}
          // Configuración para asegurar que el menú esté por encima
          menuPortalTarget={document.body}
          menuPosition={'fixed'}
          menuPlacement={'auto'}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999, fontSize: '12px' }),
          }}
        />
        {isLate && (
          <div className="input-points__late">
            <TooltipCustom title={t('lesson:Delivered late')} placement="top" hasArrow>
              <div>
                <Icon name="exclamation-circle" />
              </div>
            </TooltipCustom>
          </div>
        )}
      </div>
    </div>
  );
};

InputPointsQualitativeScale.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showDotted: PropTypes.bool,
  isLate: PropTypes.bool,
  colorsPoints: PropTypes.bool,
  evaluationScale: PropTypes.object,
  changeError: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  isScoreReadOnly: PropTypes.bool,
};

InputPointsQualitativeScale.defaultProps = {
  placeholder: '0',
  type: 'text',
  disabled: false,
  showDotted: false,
  isLate: false,
};

export default InputPointsQualitativeScale;
